import React from 'react'

const ClassroomSkeletonList = ({ count = 3 }) => {
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <div className="classroom-wellbeing-body animate-pulse" key={index}>
                    <div className="classroom-wellbeing-header" style={{ marginBottom: 20 }}>
                        <div className="classroom-year-text">
                            <div className=" bg-lightBG" style={{ height: 16, width: '160px', marginBottom: 8, borderRadius: 4 }} />
                            <div className=" bg-lightBG" style={{ height: 16, width: '60%', marginBottom: 8, borderRadius: 4 }} />
                        </div>
                        <div className="classroom-spacer" />

                        <div className="classroom-year-button">
                            <div className=" bg-lightBG" style={{ width: 24, height: 24, borderRadius: 50 }} />
                        </div>
                    </div>
                    <div className="classroom-wellbeing-row">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div className="classroom-wellbeing-student" key={i} style={{ background: '#FAFAFF' }}>
                                <div className=" bg-lightBG" style={{ marginBottom: 8, width: 48, height: 48, borderRadius: 58 }} />
                                <div className=" bg-lightBG" style={{ height: 16, width: '100%', marginBottom: 8 }} />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </>
    )
}

export default ClassroomSkeletonList
